export default __webpack_public_path__ + "static/media/DreamJobs1_15.67c34f00.png";